import axios, {
  AxiosError,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from 'axios';
import { notification } from 'ant-design-vue';

import { userStore } from '@/store/system/user';
import { ACCESS_TOKEN } from '@/store/system/user/const';
import router from '@/router';
// import router from '@/router';
// import { loginRoutePath } from '@/permission';
const baseURL = (window as unknown as { config: { apiPrefix: string } }).config
  .apiPrefix;
const timeout = 24 * 60 * 60 * 1000;

// 创建 axios 实例
export const request = axios.create({
  baseURL,
  timeout,
  // API 请求的默认前缀
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  // timeout: 6000 // 请求超时时间
});

// 设置请求头和请求路径
axios.defaults.baseURL = baseURL;
axios.defaults.timeout = timeout;

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.interceptors.request.use(
  (
    config
  ):
    | InternalAxiosRequestConfig<unknown>
    | Promise<InternalAxiosRequestConfig<unknown>> => {
    const systemUserStore = userStore();
    const { token } = systemUserStore;
    if (token) {
      config.headers![ACCESS_TOKEN] = token;
    }
    config.headers!['X-Requested-With'] = 'XMLHttpRequest';
    return config;
  },
  (error) => {
    return error;
  }
);

// 异常拦截处理器
const errorHandler = (error: AxiosError) => {
  if (error.response) {
    // const userStore = useStore();
    const data = error.response.data as Common.ResponseData<unknown>;
    // const { token } = userStore;
    if ([401, 403].includes(error.response.status)) {
      notification.error({
        message: '未登录',
        description: data.msg,
      });
      const reload = () => {
        // 重定向到登录页
        const loginPath =
          error.response?.headers.sso_login_url ||
          (window as unknown as { config: { loginPath: string } }).config
            .loginPath;
        window.location.href = `${loginPath}?redirect=${encodeURIComponent(
          window.location.hash
        )}`;
      };
      reload();
    }
    // if (error.response.status === 401 && !data.data) {
    //   notification.error({
    //     message: '登录失效',
    //     description: data.msg,
    //   });
    //   const reload = () => {
    //     setTimeout(() => {
    //       router.push(loginRoutePath);
    //     }, 1500);
    //   };
    //   if (token) {
    //     userStore.deleteToken();
    //   }
    //   reload();
    // }
  }
  return Promise.reject(error);
};
// 响应拦截
axios.interceptors.response.use((response) => {
  // 如果是文件则直接返回不校验
  if (response.config.responseType === 'blob') {
    return response;
  }
  if (response.data && response.data.code !== '0') {
    notification.error({
      message: response.data?.msg || response.data?.message, //'请求失败',
      // description: response.data?.msg || response.data?.message,
    });
    return Promise.reject(response);
  }

  if (!response || response?.data === undefined) {
    return response;
  }
  return response.data.data;
}, errorHandler);

export default axios;
